import { render } from "./edit_client.vue?vue&type=template&id=2e318ef8"
import script from "./edit_client.vue?vue&type=script&lang=js"
export * from "./edit_client.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__